import { objectToUrlParams, getCookie, sendPreflight, addSwatchesToProducts } from './ss-utils.js';

document.addEventListener('DOMContentLoaded', async function() {

    const SITE_ID = window.ssSiteId;
    const pageLoadId = window.ssPageLoadId;

    const userId = getCookie('ssUserId') || '';
    const sessionId = getCookie('ssSessionIdNamespace') || '';

    const defaultParams = {
        siteId: SITE_ID,
        resultsFormat: 'json',
        resultsPerPage: 4,
        page: 1,
        userId,
        sessionId,
        pageLoadId,
        domain: window.location.href,
        redirectResponse: 'minimal'
    }

    const featuredCollections = document.querySelectorAll('.ss-featured-collection');

    featuredCollections.forEach(async (featuredCollection) => {
        const collectionHandle = featuredCollection.dataset.collectionHandle;
        const limit = featuredCollection.dataset.limit;
        await performSearch(collectionHandle, limit);
    });

    // Function to perform the search query
    async function performSearch(collectionHandle, limit) {
        const productCards = new ProductCards(`ss-featured-collection-${collectionHandle}`);

        productCards.renderSkeletons(4);

        const searchParams = {
            ...defaultParams,
            'bgfilter.collection_handle': collectionHandle,
            'bgfilter.limit': limit,
        }

        const queryString = objectToUrlParams(searchParams);

        // Build the SearchSpring API URL with the query parameter
        const apiUrl = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?bgfilter.status=active&${queryString}`;

        try {
            // Send preflight request first
            await sendPreflight();

            // Make the GET request to the SearchSpring API
            const response = await fetch(apiUrl);

            // Handle redirects
            if (response.redirected) {
                window.location.href = response.url;
                return;
            }

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // Process products with swatches
            const productsWithSwatches = await addSwatchesToProducts(data.results);

            // Add inline merchandising to results
            if (data.merchandising?.content?.inline?.length > 0) {
                data.merchandising.content.inline.forEach(item => {
                    const content = item.value;
                    const {index} = item.config?.position || 0;
                    productsWithSwatches.splice(index, 0, {
                        content,
                        isMerchandising: true,
                    });
                });
            }

            // Render the products
            productCards.render(productsWithSwatches, true);

            // Handle merchandising content
            if (Object.keys(data?.merchandising?.content || {}).length > 0) {
                processSearchMerchandisingContent(data.merchandising.content);
            }

        } catch (error) {
            // Don't log errors for intentional redirects
            if (!error.message.startsWith('Redirecting to')) {
                console.error('Error fetching search results:', error);
            }
        }
    }

    // Helper function to process merchandising content
    function processSearchMerchandisingContent(merchandisingContent) {
        Object.keys(merchandisingContent).forEach(key => {
            const targetElement = document.getElementById(`ss-merchandising-${key}`);

            if (!targetElement || !Array.isArray(merchandisingContent[key])) return;

            // Clear any existing content
            targetElement.innerHTML = '';

            // Process each HTML element for this key
            merchandisingContent[key].forEach(htmlContent => {
                // Check if content is wrapped in script tags and remove them
                const scriptRegex = /^<script[^>]*>([\s\S]*)<\/script>$/i;
                const match = scriptRegex.exec(htmlContent);
                const cleanContent = match && match[1] ? match[1].trim() : htmlContent;

                // Append the cleaned content
                targetElement.innerHTML += cleanContent;
            });
        });
    }
});

